import { Injectable } from '@angular/core';
import { Language } from '../models/language';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { WindowRef } from './window.service';

@Injectable()
export class LanguageService {

  public static language$: ReplaySubject<Language> = new ReplaySubject<Language>(1);

  constructor(private windowRef: WindowRef) {
    const OLBLoginDefaultLanguage: Language = this.windowRef.nativeWindow.globalServices.AnonymousLanguageService.language;
    if (OLBLoginDefaultLanguage) {
      LanguageService.language$.next(OLBLoginDefaultLanguage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/language.service.ts